var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocRep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 10.9907C9.5625 11.6372 9.81931 12.2572 10.2764 12.7143C10.7335 13.1714 11.3535 13.4282 12 13.4282C12.6465 13.4282 13.2665 13.1714 13.7236 12.7143C14.1807 12.2572 14.4375 11.6372 14.4375 10.9907C14.4375 10.3443 14.1807 9.72427 13.7236 9.26715C13.2665 8.81003 12.6465 8.55322 12 8.55322C11.3535 8.55322 10.7335 8.81003 10.2764 9.26715C9.81931 9.72427 9.5625 10.3443 9.5625 10.9907Z",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5963 15.5868L13.1489 19.0342C12.8442 19.3386 12.4311 19.5096 12.0004 19.5096C11.5697 19.5096 11.1566 19.3386 10.8519 19.0342L7.40369 15.5868C6.49468 14.6777 5.87565 13.5195 5.62487 12.2587C5.3741 10.9978 5.50284 9.6909 5.99482 8.5032C6.4868 7.3155 7.31992 6.30036 8.38883 5.58615C9.45774 4.87193 10.7144 4.49072 12 4.49072C13.2856 4.49072 14.5423 4.87193 15.6112 5.58615C16.6801 6.30036 17.5132 7.3155 18.0052 8.5032C18.4972 9.6909 18.6259 10.9978 18.3751 12.2587C18.1243 13.5195 17.5053 14.6777 16.5963 15.5868Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocRep);
export default __webpack_public_path__ + "static/media/loc_rep.f32b1eed687423034e9f9b21e79413fe.svg";
export { ForwardRef as ReactComponent };